import { apiSlice } from "../../app/api/apiSlice";

import { setCurrentUserName } from "./verifySlice";

export const verifyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    resend: builder.mutation({
      query: (username) => ({
        url: "/register/resend",
        method: "POST",
        body: { ...username },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const { verifyUserName } = data;

          dispatch(setCurrentUserName({ username: verifyUserName }));
        } catch (err) {
          console.error(err);
        }
      },
    }),
    verify: builder.mutation({
      query: (formData) => ({
        url: "/register/verify",
        method: "POST",
        body: { ...formData },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const { verifyUserName } = data;

          dispatch(setCurrentUserName({ username: verifyUserName }));
        } catch (err) {
          console.error(err);
        }
      },
    }),
  }),
});

export const { useResendMutation, useVerifyMutation } = verifyApiSlice;
